import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  id: "e9OQsJvkrHt1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 473 426.9",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision"
}, [
  /*#__PURE__*/_createVNode("defs", null, [
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt5-fill",
      x1: "201.0389",
      y1: "392.2643",
      x2: "254.2851",
      y2: "392.2643",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt5-fill-0",
        offset: "0%",
        "stop-color": "#003c6a"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt5-fill-1",
        offset: "62%",
        "stop-color": "#006290"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt5-fill-2",
        offset: "100%",
        "stop-color": "#0075a3"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt6-fill",
      x1: "107.6399",
      y1: "272.1645",
      x2: "401.6842",
      y2: "470.0432",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt6-fill-0",
        offset: "0%",
        "stop-color": "#004969"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt6-fill-1",
        offset: "100%",
        "stop-color": "#0075a3"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt11-fill",
      x1: "165.4635",
      y1: "70.7305",
      x2: "321.4635",
      y2: "70.7305",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt11-fill-0",
        offset: "0%",
        "stop-color": "#ff7600"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt11-fill-1",
        offset: "100%",
        "stop-color": "#ff9c00"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt18-fill",
      x1: "-38.4904",
      y1: "-0.0433",
      x2: "38.4812",
      y2: "-0.0433",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt18-fill-0",
        offset: "0%",
        "stop-color": "#ff7600"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt18-fill-1",
        offset: "100%",
        "stop-color": "#ff9c00"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt107-fill",
      x1: "318.3222",
      y1: "230.0009",
      x2: "393.9107",
      y2: "230.0009",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt107-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt107-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt108-fill",
      x1: "328.0666",
      y1: "235.5822",
      x2: "406.9295",
      y2: "235.5822",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt108-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt108-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt109-fill",
      x1: "335.2779",
      y1: "235.7141",
      x2: "400.5984",
      y2: "235.7141",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt109-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt109-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt110-fill",
      x1: "381.500129",
      y1: "239.9995",
      x2: "418.669629",
      y2: "239.9995",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt110-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt110-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt111-fill",
      x1: "385.95361",
      y1: "242.6186",
      x2: "423.12311",
      y2: "242.6186",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt111-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt111-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt112-fill",
      x1: "315.985194",
      y1: "267.1327",
      x2: "357.136294",
      y2: "267.1327",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt112-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt112-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt113-fill",
      x1: "320.190654",
      y1: "269.116643",
      x2: "360.125815",
      y2: "270.300058",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt113-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt113-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt114-fill",
      x1: "340.166803",
      y1: "189.5101",
      x2: "382.754303",
      y2: "189.5101",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt114-fill-0",
        offset: "0%",
        "stop-color": "#0073bf"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt114-fill-1",
        offset: "100%",
        "stop-color": "#b9edff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt115-fill",
      x1: "344.068747",
      y1: "190.763834",
      x2: "386.540112",
      y2: "192.161525",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt115-fill-0",
        offset: "0%",
        "stop-color": "#0097f9"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt115-fill-1",
        offset: "100%",
        "stop-color": "#17d3ff"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt125-fill",
      x1: "356.6096",
      y1: "310.8903",
      x2: "323.6103",
      y2: "253.7339",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt125-fill-0",
        offset: "0%",
        "stop-color": "#ff9c00"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt125-fill-1",
        offset: "100%",
        "stop-color": "#ffdd54"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt126-fill",
      x1: "344.2202",
      y1: "405.851",
      x2: "344.2202",
      y2: "255.3244",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt126-fill-0",
        offset: "0%",
        "stop-color": "#ff9c00"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt126-fill-1",
        offset: "50.55%",
        "stop-color": "#ffb300"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt126-fill-2",
        offset: "100%",
        "stop-color": "#ffc600"
      })
    ]),
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "e9OQsJvkrHt128-fill",
      x1: "326.9318",
      y1: "303.9307",
      x2: "369.2912",
      y2: "303.9307",
      spreadMethod: "pad",
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(0 0)"
    }, [
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt128-fill-0",
        offset: "0%",
        "stop-color": "#f3eefa"
      }),
      /*#__PURE__*/_createVNode("stop", {
        id: "e9OQsJvkrHt128-fill-1",
        offset: "100%",
        "stop-color": "#efefef"
      })
    ])
  ]),
  /*#__PURE__*/_createVNode("g", null, [
    /*#__PURE__*/_createVNode("g", null, [
      /*#__PURE__*/_createVNode("g", {
        id: "e9OQsJvkrHt4_to",
        transform: "translate(63.085886,491.850029)"
      }, [
        /*#__PURE__*/_createVNode("g", { transform: "translate(-236.50001,-368.612488)" }, [
          /*#__PURE__*/_createVNode("path", {
            d: "M0,360.6v9.1c0,2.9,3.4,5.7,10.1,7.4L202,423.5c18.3,4.4,40.9,4.4,59.2,0l201.7-49.4c6.6-1.6,10-4.4,10.1-7.2v0-9.3l-473,3Z",
            fill: "url(#e9OQsJvkrHt5-fill)"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M10.1,366.2L202,404.6c18.3,3.7,40.9,3.7,59.2,0l201.7-40.8c13.5-2.7,13.5-9.5,0-12.2L271,313.2c-18.3-3.7-40.9-3.7-59.2,0L10.1,354c-13.5,2.7-13.5,9.5,0,12.2v0Z",
            fill: "url(#e9OQsJvkrHt6-fill)"
          })
        ])
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "e9OQsJvkrHt7_to",
        transform: "translate(246.950007,-154.449997)"
      }, [
        /*#__PURE__*/_createVNode("g", { transform: "translate(-246.950005,-210.549995)" }, [
          /*#__PURE__*/_createVNode("path", {
            d: "M183.8,56.1h126.3c13.5,0,24.4,10.9,24.4,24.4v260.1c0,13.5-10.9,24.4-24.4,24.4h-126.3c-13.5,0-24.4-10.9-24.4-24.4v-260.2c.1-13.4,11-24.3,24.4-24.3Z",
            fill: "#4d4d4d",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("path", { d: "M185.2,57.8h116.5c12.3,0,22.3,10,22.3,22.3v259.5c0,12.3-10,22.3-22.3,22.3h-116.5c-12.3,0-22.3-10-22.3-22.3v-259.5c.1-12.3,10-22.3,22.3-22.3Z" }),
          /*#__PURE__*/_createVNode("path", {
            d: "M300.7,60.3h-30.6c.1.4.2.7.2,1.1v1.8c0,2.5-2.1,4.6-4.6,4.6h-43.8c-2.6,0-4.6-2.1-4.6-4.6v-1.8c0-.4.1-.8.2-1.1h-31.1c-11.5,0-20.8,9.3-20.8,20.8v258c0,11.5,9.3,20.8,20.8,20.8h114.4c11.5,0,20.8-9.3,20.8-20.8v-258c-.1-11.5-9.4-20.8-20.9-20.8v0Z",
            fill: "#263238",
            stroke: "#263238",
            "stroke-width": "0.25",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M300.7,60.3h-30.6c.1.4.2.7.2,1.1v1.8c0,2.6-2.1,4.6-4.6,4.6h-43.8c-2.6,0-4.6-2.1-4.6-4.6v-1.8c0-.4.1-.8.2-1.1h-31.1c-11.5,0-20.8,9.3-20.8,20.8h156c-.1-11.5-9.4-20.8-20.9-20.8v0Z",
            fill: "url(#e9OQsJvkrHt11-fill)"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M253.9,65.1h-20.9c-1.2,0-2.1-1-2.1-2.2v0c0-1.2,1-2.1,2.1-2.1h20.9c1.2,0,2.1,1,2.1,2.1v0c.1,1.2-.9,2.2-2.1,2.2v0v0Z",
            fill: "#263238",
            stroke: "#263238",
            "stroke-width": "0.25",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "198.5",
            y1: "277.1",
            x2: "290.1",
            y2: "277.1",
            fill: "none",
            stroke: "#fff",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "198.5",
            y1: "289.1",
            x2: "290.1",
            y2: "289.1",
            fill: "none",
            stroke: "#fff",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "198.5",
            y1: "301.2",
            x2: "290.1",
            y2: "301.2",
            fill: "none",
            stroke: "#fff",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M206.9,165.1c-14.2,20.6-9,48.9,11.6,63.1s48.9,9,63.1-11.6s9-48.9-11.6-63.1c-7.6-5.2-16.6-8-25.8-8-2.8,0-5.6.3-8.3.8",
            fill: "none",
            stroke: "#fff",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("g", {
            id: "e9OQsJvkrHt17_ts",
            transform: "translate(244.299995,190.899994) scale(1,1)"
          }, [
            /*#__PURE__*/_createVNode("g", { transform: "translate(-244.299995,-190.899994)" }, [
              /*#__PURE__*/_createVNode("circle", {
                r: "38.5",
                transform: "matrix(1.313466 0 0 1.26427 244.300002 190.900002)",
                fill: "url(#e9OQsJvkrHt18-fill)"
              })
            ])
          ]),
          /*#__PURE__*/_createVNode("g", {
            id: "e9OQsJvkrHt19_ts",
            transform: "translate(243.850006,191.799995) scale(0.161039,0.208789)"
          }, [
            /*#__PURE__*/_createVNode("polyline", {
              points: "224.6,192.1 239.2,208.7 263.1,174.9",
              transform: "translate(-243.850006,-191.799995)",
              fill: "none",
              stroke: "#263238",
              "stroke-width": "6",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "e9OQsJvkrHt20_to",
        transform: "translate(124.9,-13.756062)"
      }, [
        /*#__PURE__*/_createVNode("g", { transform: "translate(-206.954769,-126.949997)" }, [
          /*#__PURE__*/_createVNode("line", {
            x1: "53.6",
            y1: "145.2",
            x2: "53.6",
            y2: "154",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "58",
            y1: "149.6",
            x2: "49.1",
            y2: "149.6",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "356.2",
            y1: "69.2",
            x2: "356.2",
            y2: "78",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "360.7",
            y1: "73.6",
            x2: "351.8",
            y2: "73.6",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "230.2",
            y1: "0.5",
            x2: "230.2",
            y2: "9.4",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "234.7",
            y1: "4.9",
            x2: "225.8",
            y2: "4.9",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "84.2",
            y1: "244.5",
            x2: "84.2",
            y2: "253.4",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("line", {
            x1: "88.7",
            y1: "248.9",
            x2: "79.8",
            y2: "248.9",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M352.3,37.2c0,4.1-3.3,7.3-7.3,7.3s-7.3-3.3-7.4-7.3s3.3-7.3,7.3-7.4v0c4.1.1,7.4,3.3,7.4,7.4Z",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("g", null, [
            /*#__PURE__*/_createVNode("circle", {
              r: "7.3",
              transform: "translate(35.6 206.5)",
              fill: "none",
              stroke: "#263238",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ]),
          /*#__PURE__*/_createVNode("path", {
            d: "M385.6,112.2c.1.9-.6,1.7-1.5,1.8s-1.7-.6-1.8-1.5c0-.1,0-.2,0-.3.1-.9.9-1.6,1.8-1.5.8,0,1.4.7,1.5,1.5Z",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M131.3,88.2c0,.9-.7,1.7-1.7,1.7s-1.7-.7-1.7-1.7.7-1.7,1.7-1.7v0c.9,0,1.7.8,1.7,1.7v0Z",
            fill: "none",
            stroke: "#263238",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ])
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "e9OQsJvkrHt34_to",
        transform: "translate(-96.243449,283.633048)"
      }, [
        /*#__PURE__*/_createVNode("g", { transform: "translate(-151.394249,-239.71843)" }, [
          /*#__PURE__*/_createVNode("g", null, [
            /*#__PURE__*/_createVNode("path", {
              d: "M75,196.1c-1.6.2-2.9.8-4.2,1.7-.4.3-.7.6-1.1.9-.3.3-.4.6-.8.7-.5.2-1,.3-1.5.4-.5,0-.9-.1-1.4,0-.4.1-.9.4-1,.8-.1.5.3.9.7,1.1c1.1.6,2.6.6,3.8.2.6-.2,1.1-.4,1.8-.5c1.1-.1,2.2.4,3.3.3.8,0,1.6-.4,2.4-.3c1,.1,1.9.5,2.9.6.8.1,1.7-.1,2.4-.5s1.2-1.2,1.1-1.9c-.1-.9-.7-1.1-1.3-1.6-.7-.5-1.3-1-2.2-1.4-1.4-.6-3.2-.7-4.9-.5v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M106.4,204.4c-2.7-1.3-5.5-2.3-8.3-3.4-4.5-1.7-9.1-3.1-13.9-3.5-1.3-.1-2.6-.2-3.9-.2-1,0-2.4-.2-3,.8-.1.1-.1.2-.2.3-.4,1.3,1.5,2.3,2.4,2.9c1.4,1,2.8,2.1,4.3,3.1c1.5,1.1,8.3,4.9,10,5.9c1.8,1,3.4,2.1,5.1,3.2c1.1.7,2.1,1.3,3.2,1.9.6.3,1.2.7,1.8,1c.1-1.7.2-3.6.8-5.2.3-1,1-2,1.2-3c0-.1,0-.2,0-.2.1-.6.1-1.2.1-1.8.2-.1.4-1.7.4-1.8v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M104.2,205.8c.2.7.2,1.5.1,2.2-.1.5-.3.9-.2,1.4c0,.5.1,1,.1,1.5c0,1-.1,2.1-.6,3-.3.6-.8,1.1-1.4,1.5-1.1-.6-2.2-1.3-3.2-1.9-1.7-1.1-3.3-2.2-5.1-3.2-1.7-.9-8.5-4.7-10-5.9-1.4-1-2.8-2.1-4.3-3.1-.9-.6-2.8-1.6-2.4-2.9c1.4.4,2.6,1.1,3.8,1.9c4.7,3.1,9.3,6.6,14.8,8c.8.2,1.8.4,2.6,0c.8-.3,1.4-1.2,1.9-1.9.2-.3.5-.5.7-.8c1-.9,2.2-1.5,3.5-1.9-.2.1-.4.9-.4,1.1c0,.4,0,.7.1,1v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M119.9,209.3c-1.2,3.2-3.2,6-5,9-.5.9-1.2,1.9-1.6,3-.4.9-.7,1.8-.9,2.7s-.4,1.8-.6,2.7c-.2.7-.6,2.3-.3,3.1-1.3-2.8-3.5-5.1-5.6-7.3-1.1-1.1-2.2-2.3-3.2-3.4s-2-2.3-2.2-3.7c0-.3,0-.6-.1-.9-.2-2.4-.2-4.8.6-7.1.4-1.1.9-2.1,1.8-2.9.5-.5,1.2-.8,1.9-1c.1,0,.2-.1.4-.1c1-.2,1.7.2,2.6.6c4,1.3,8.3.4,12.3,1.2.5,1.2.4,2.8-.1,4.1v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M114,207.1c-.3.1-.3,2.6-.3,2.9-.1,1-.1,1.9-.2,2.8-.3,2-.4,4.1-.3,6.1c0,.8.1,1.6.1,2.3-.4.9-.7,1.8-.9,2.7s-.4,1.8-.6,2.7c-.2.7-.6,2.3-.3,3.1-1.3-2.8-3.5-5.1-5.6-7.3-1.1-1.1-2.2-2.3-3.2-3.4s-2-2.3-2.2-3.7c0-.3,0-.6-.1-.9.6.7,1.2,1.4,1.9,2.1s1.5,1.7,2.5,2.3c.3.2.6.3.9.3c2.2.4,2.2-3,2.6-4.3.5-1.7.9-3.5,2.1-4.9.6-.7,1.2-1.3,2-1.9.6-.4,1.1-.8,1.6-.9v0Z",
                fill: "#f0ece1"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M154.2,358.2c-.5,1-1.5,1.7-2.1,2.6-.7,1.3-.6,2.9-1.4,4.2-.7,1.3-1.8,2.4-3.1,3.2-2,1.3-4.4,1.9-6.7,2.3-1.1.1-2.5.3-3.7,0-.8-.2-1.4-.5-1.8-1.2s-.4-1.5-.1-2.2c.4-1.1,6.1-8.3,6.8-9.6.6-1.1,1.2-2.3,1.6-3.5.1-.3.2-.6.2-1c.2-.8.3-1.6.6-2.3.8-1.9,4-2.1,5.7-1.5c2,.8,3.4,2.6,4.1,4.5.6,1.4.7,3.1-.1,4.5v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M154.2,358.2c-.5,1-1.5,1.7-2.1,2.6-.7,1.3-.6,2.9-1.4,4.2-.7,1.3-1.8,2.4-3.1,3.2-2,1.3-4.4,1.9-6.7,2.3-1.1.1-2.5.3-3.7,0c1.8-.4,3.5-.9,5.2-1.6c2.4-1.1,4.6-2.7,5.6-5c.6-1.3.9-2.7,1.4-4c.3-.8.7-1.5,1.2-2.3.4-.7.8-1.2.6-2-.1-.2-.2-.5-.3-.7-.5-.5-1.2-.5-1.8-.5-.8,0-1.6.1-2.3,0-1.1-.1-2.1-.6-2.9-1.4.2-.8.3-1.6.6-2.3.8-1.9,4-2.1,5.7-1.5c2,.8,3.4,2.6,4.1,4.5.6,1.4.7,3.1-.1,4.5v0Z",
                fill: "#f0ece1"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M120.2,359.1c0,.6-.1,1.1-.4,1.6-.6,1.1-1.8,1.8-3.1,2.1-.7.1-1.4.2-2.1.5-.7.2-1.4.6-2,1-.5.4-1,.9-1.4,1.3-1.9,1.9-4.2,3.4-6.8,4.4-1.6.7-3.5,1.1-5.2.9-.7-.1-1.5-.4-2.1-.8-.8-.6-1.5-1.4-1.6-2.3-.5-2.6,2.2-5.2,4.4-6.5c1.7-.9,3.6-1.3,5.3-2c1.3-.6,2.5-1.4,3.5-2.3.6-.6,1.2-1.2,1.7-1.9.1-.1.2-.3.3-.4.5-.7.9-1.4,1.6-1.9s1.8-.4,2.6-.3s1.6.3,2.3.6c1.2.5,2.1,1.5,2.6,2.6.3,1,.4,2.2.4,3.4v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M120.2,359.1c0,.6-.1,1.1-.4,1.6-.6,1.1-1.8,1.8-3.1,2.1-.7.1-1.4.2-2.1.5-.7.2-1.4.6-2,1-.5.4-1,.9-1.4,1.3-1.9,1.9-4.2,3.4-6.8,4.4-1.6.7-3.5,1.1-5.2.9-.7-.1-1.5-.4-2.1-.8c2.1,0,4.1-.3,6-1c4.9-2,7.7-6.9,12.4-9.3.7-.4,1.6-.9,1.5-1.6s-.9-1-1.7-1.2c-.9-.2-1.8-.3-2.7-.6-.8-.2-1.7-.6-2.2-1.3.1-.1.2-.3.3-.4.5-.7.9-1.4,1.6-1.9s1.8-.4,2.6-.3s1.6.3,2.3.6c1.2.5,2.1,1.5,2.6,2.6.3,1,.4,2.2.4,3.4v0Z",
                fill: "#f0ece1"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M133.2,277.5c0,.3,0,.6-.1.9-.5,7.8-1.5,15.6-3,23.3-.2,1.2-.5,2.4-.7,3.7-.4,2.4-.9,4.7-1.3,7.1s-.9,4.7-1.3,7.1c-.5,2.4-.9,4.8-1.4,7.1-.5,2.4-1,4.7-1.5,7.1s-1.1,4.7-1.6,7.1-1.2,4.7-1.8,7c-.3,1.2-.7,2.3-1,3.5-.2.6-.4,1.1-.5,1.7-.1.5-.2,1-.6,1.4-.3.3-.8.5-1.3.6-.3.1-.6.2-.9.2-.7.1-1.5.2-2.2.1-1.1-.1-2.1-.4-3.1-.9-.1,0-.1-.1-.2-.1c0-.1,0-.1,0-.2c0-.2,2.1-69.9,2.1-70.9c0-.3,0-.6,0-1c.1-2.1.4-4.2.6-6.4.1-2.2.3-4.5,1-6.6c0-.1.1-.2.1-.2.1,0,.2.1.3.2.3.5.5,1,.9,1.4.4.5.9.8,1.5,1.2c1,.7,2.2,1.3,3.2,1.9c4.4,2.6,9,3.6,12.5-.7.4,1.4.3,3,.3,4.4v0Z",
              fill: "#483e49"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M133.2,277.5c0,.3,0,.6-.1.9-.5,7.8-1.5,15.6-3,23.3-.2,1.2-.5,2.4-.7,3.7-.4,2.4-.9,4.7-1.3,7.1s-.9,4.7-1.3,7.1c-.5,2.4-.9,4.8-1.4,7.1-.5,2.4-1,4.7-1.5,7.1s-1.1,4.7-1.6,7.1-1.2,4.7-1.8,7c-.3,1.2-.7,2.3-1,3.5-.2.6-.4,1.1-.5,1.7-.1.5-.2,1-.6,1.4-.3.3-.8.5-1.3.6-.3.1-.6.2-.9.2c1.4-14.7,4.3-29.3,5.4-44.1.3-4.3.6-8.6.7-13c.1-3.8.2-10.1-3.8-12.4-1.7-1-3.5-1.9-5-3.1-.2-.2-.4-.3-.7-.4c0-.6.1-1.2.1-1.8c0-.8.1-1.7.1-2.5c0-.7.1-1.4.1-2.1c0-.6.1-1.2.1-1.8c0-.5.1-.9.1-1.4c0-.3.1-.6.1-.9.1-.3.1-.7.2-1c.1-.5.4-1.1.9-1c.2,0,.4.3.6.5c1.3,1.6,3.3,2.5,5.1,3.6c4.4,2.6,9,3.6,12.5-.7.6,1.3.5,2.9.5,4.3v0Z",
                fill: "#483e49"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M152.9,350.6c0,.2-.1.4-.2.6s-.4.5-.6.6c-.5.3-1,.6-1.5.8-1.6.6-3.5.7-5.2.2-.3-.1-.7-.2-.9-.5-.3-.3-.4-.8-.5-1.2-.2-.8-.4-1.6-.6-2.4-2-8.8-12.2-52.3-13.4-56.9-.6-2.3-1.1-4.5-1.6-6.8-.6-2.5-1.1-5-1.6-7.5-.7-3.1-1.3-6.3-1.9-9.5c1.1,2.3,2.3,4.6,4,6.5.8.9,2.7.6,3.8.7c5.7.3,11.5-.4,17-1.9.4-.1.9-.2,1.2,0c.2.1.3.3.5.6c1.5,2.8,1.9,6,2.2,9.1.2,3,.3,6.1.3,9.1c0,2.1-.1,4.2-.3,6.3-.4,5.8-1.4,11.4-.6,17.3.4,2.8,1,5.7,1.4,8.5.1.7.2,1.5.3,2.2c1.1,8.2,0,16.2-1.8,24.2v0Z",
              fill: "#483e49"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M152.9,350.6c0,.2-.1.4-.2.6s-.4.5-.6.6c-.5.3-1,.6-1.5.8-.6-18.5-1.3-36.9-1.9-55.4-.1-3.7-.7-8-4.1-9.8-2.1-1.1-4.6-.9-7-.9-2.7,0-6.3-.2-9.1-1.4-.6-2.5-1.1-5-1.6-7.5-.7-3.1-1.3-6.3-1.9-9.5c1.1,2.3,2.3,4.6,4,6.5.8.9,2.7.6,3.8.7c5.7.3,11.5-.4,17-1.9.4-.1.9-.2,1.2,0c.2.1.3.3.5.6c1.5,2.8,1.9,6,2.2,9.1.2,3,.3,6.1.3,9.1c0,2.1-.1,4.2-.3,6.3-.4,5.8-1.4,11.4-.6,17.3.4,2.8,1,5.7,1.4,8.5.1.7.2,1.5.3,2.2c1,8.1-.1,16.1-1.9,24.1v0Z",
                fill: "#483e49"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M160.4,224.9c-.2.6-.5,1.2-.7,1.7-.2.4-.3.7-.5,1-4.2,7.7-7.5,15.5-8.5,24.1-.6,5.3-.1,10.7.7,15.9.3,2.3.6,4.7,1.2,6.9.6,1.9.6,3.1-1.1,4.6-1.1.9-2.5,1.5-3.8,2-1.5.6-3.1,1-4.7,1.4-7.6,1.9-15.7,1.8-23.2-.2-2.2-.6-4.5-1.3-6.3-2.6-2-1.4-.9-2.9-.9-4.9-.2-9.2-1.8-37.3-2.2-42.2-.5-5.6-.6-11.2-.4-16.8.1-2.7.3-5.5,1.8-7.8c3.1-4.8,9-4.4,14.1-3.3c6.7,1.4,13.1,3.7,19.4,6c2.8,1,5.5,2.1,8.3,3.1c2.3.9,4.7,2,6.2,4c1.4,2.4,1.3,4.8.6,7.1v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M122.1,212.3c-.3.6-.8,1.1-1.3,1.7-1,1.4-1.3,3-1.5,4.6-.2,2.2-.2,4.5-.1,6.7.1,3.1.2,6.3.3,9.4.1,3,.2,6-.3,8.9-.3,2.1-1,4.3-2.1,6.1-.4.7-.9,1.4-1.5,2.1-1.1,1.3-2.6,2.3-4.3,3-.5-9.7-1.1-19.5-1.3-22.2-.5-5.6-.6-11.2-.4-16.8c0-.9.1-1.9.2-2.8.2-.3.5-.6.8-.9c1.6-1.5,4-1.8,6.3-2c1.8,0,6.7-.5,5.2,2.2v0Z",
              fill: "#f0e1b6"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M116.3,244.4c-.1,1-.7,2-1.6,2.5-.5.3-1,.4-1.5.5-1,.2-1.9.2-2.8.7-.8.4-1.6,1-2.2,1.7-1,1-1.8,2.2-2.8,3.2s-2.1,1.8-3.5,2.3c-1.3.5-2.8.7-4.3.4-.5-.1-.8-.2-1.1-.5-.6-.5-.7-1.3-.6-2.3.1-.9.2-1.8.6-2.6.7-1.5,2.2-2.4,3.6-3.4.1-.1.2-.1.3-.2c2.1-1.5,4.2-3.1,5.7-5.2.1-.1.1-.2.2-.3.5-.8,1-1.5,1.9-1.9.9-.5,2-.7,3.1-.6c1.7.2,3.3,1.2,4.2,2.6.6,1.1.9,2.2.8,3.1v0Z",
              fill: "#fd8480"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M116.3,244.4c-.1,1-.7,2-1.6,2.5-.5.3-1,.4-1.5.5-1,.2-1.9.2-2.8.7-.8.4-1.6,1-2.2,1.7-1,1-1.8,2.2-2.8,3.2s-2.1,1.8-3.5,2.3c-1.3.5-2.8.7-4.3.4-.5-.1-.8-.2-1.1-.5c3.1-.4,6.1-1.9,8.2-4.1c1.1-1.1,1.9-2.4,3-3.5c1.2-1.1,2.6-2,3.9-3c.4-.3.8-.6.8-1s-.3-.7-.7-.9-.8-.2-1.2-.2c-1.3-.1-2.6-.1-3.7-.7-.3-.2-.5-.4-.7-.6.5-.8,1-1.5,1.9-1.9.9-.5,2-.7,3.1-.6c1.7.2,3.3,1.2,4.2,2.6.8,1.1,1.1,2.2,1,3.1v0Z",
              fill: "#fdb4b1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M145,199.1c-.1.5-.3,1-.5,1.5-.6,1.4-1.4,2.8-2.2,4.1-.6,1-1.7,1.8-2.7,2.4-1.8,1-3.9,1.8-6,2.4-.4.1-.8.2-1.2.4-1.8.5-3.7,1.1-5.5,1.6-3.9,1.1-7.9,2.2-11.9,3.1-.8.2-1.6.4-2.4.6.1.4.3.7.4,1.1.7,2.3.9,4.7.9,7.1c0,2.1,0,4.3,0,6.4c0,2,.1,4.1.1,6.1c0,.9,0,1.7,0,2.6c0,.7.2,1.3-.5,1.9-.3.2-.6.4-.9.6-.6.3-1.2.5-1.9.6-1,.2-2.1.2-3.1.2-.7,0-1.5-.1-1.6-.8-.1-.5-.3-1.1-.5-1.6-.4-1.1-.7-2.3-1.1-3.5-.7-2.3-1.4-4.6-2-7-.8-3-1.5-6-2.1-9-.4-2.2-.9-4.4-1.1-6.6-.1-1.1-.2-2.3-.2-3.4.1-2.6,2.9-4.4,4.9-5.9.3-.2,12.5-7.7,16.2-9.7c3.9-2.2,7.8-4.3,11.8-6.5.1.5.3,1.1.7,1.5.5.3,1.1.2,1.6.3c1.3.4,2.5,1,3.6,1.8.1,0,.1.1.2.1.3.2.6.5.9.7.4.2,1,.3,1.5.5c2.1.7,3.7,2.4,4.4,4.4.2.7.3,1.4.2,2v0Z",
              fill: "#5289a1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M145,199.1c-.1.5-.3,1-.5,1.5-.6,1.4-1.4,2.8-2.2,4.1-.6,1-1.7,1.8-2.7,2.4-1.8,1-3.9,1.8-6,2.4-1.1-.5-2.1-1.2-2.7-2.2-.3-.5-.5-1-.7-1.5-.7-2.4-.3-5,.7-7.3s2.7-4.3,4.4-6.2l1.2.2c.3-.5.8-.9,1.3-1.2.1,0,.1.1.2.1.3.2.6.5.9.7.4.2,1,.3,1.5.5c2.1.7,3.7,2.4,4.4,4.4.2.8.3,1.5.2,2.1v0Z",
              fill: "#5289a1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M126.9,211.5c-3.9,1.1-7.9,2.2-11.9,3.1-.8.2-1.6.4-2.4.6.1.4.3.7.4,1.1.7,2.3.9,4.7.9,7.1c0,2.1,0,4.3,0,6.4c0,2,.1,4.1.1,6.1c0,.9,0,1.7,0,2.6c0,.7.2,1.3-.5,1.9-.3.2-.6.4-.9.6-1.1-7.6-2.2-15.1-3.3-22.7-.3-2.1-.5-4.5.9-6.1c1.3-1.5,3.7-2.1,4.5-3.8.5-1.1.3-2.4.1-3.6-.3-2.2-1-7.1,2.1-7.8.9-.2,1.8-.1,2.7.2c1.9.5,3.6,1.7,4.8,3.2c1,1.3,1.6,2.9,2,4.6.7,2,.8,4.3.5,6.5v0Z",
              fill: "#5289a1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M156.6,130.3c.5.2.9.4,1.3.6c3.1,1.7,5.7,4.2,8.6,6.2s6.4,3.7,10,3.2c-1.5,1.2-3.4,1.9-5.4,2.1s-3.9-.1-5.9-.5c2.1.4,4,1.4,5.5,2.9c1,1,1.7,2.2,2.8,3.2c2.5,2.3,6.3,2.9,9.8,3.4-5.8,2.2-12.5,2.2-18.2-.1c2.6.9,3.9,3.5,4.4,6c.4,2.5.1,5.1.7,7.6-.8-1.8-3-2.7-5.1-3-2.1-.2-4.2.1-6.3-.2-4.4-.5-8.1-3.2-11.5-5.8-2-1.5-2.1-3.1-2.6-5.3-.5-2.3-.8-4.6-1.3-6.9-.2-1.1-.4-2.3-.7-3.4-.2-1-.7-1.7-1-2.7-.3-1.1-.2-2-.1-3c.2-1.5-.6-3.4,1.1-4.5c1.3-.9,3.5-1.4,5-1.5c3.1,0,6.2.5,8.9,1.7v0Z",
              fill: "#94ebe1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M158.8,138.9c2.5,3,4,6.8,6.9,9.5-1.5-.5-3-.8-4.6-1.1c2.4,3.1,3.5,6.9,3.3,10.6-.3,3.8-2,7.4-4.7,10.2-.6-1-1.9-1.5-3.1-2-3-1.1-5.9-2.6-8.6-4.2-1.6-1-3.1-2-4.3-3.4-2.1-2.4-2.9-5.6-3.4-8.7-.5-3.5-.6-7-.3-10.5.1-1.3.3-2.5.7-3.7.5-1.3,1.3-2.5,2.4-3.5c1.2-1,2-1.5,3.5-1c3,1.1,5.9,2.4,8.4,4.2c1.4,1.1,2.7,2.2,3.8,3.6v0Z",
              fill: "#94ebe1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M126.3,155.8c-.1.2-.2.4-.3.5-.2.1-.4.1-.6.1-.5-.1-1-.4-1.5-.7-2.2-1.4-4.2-3.3-6.1-5.6-1.1-1.3-2.1-2.7-2.2-5.1c0-.3,0-.5,0-.8.1-1.8.6-3.6,1.1-5.2c2.1-6.1,5.1-11.3,7.7-16.9.4-1,.9-1.9,1.3-2.9.6-1.4,1.3-2.8,1.8-4.2s.9-2.9,1.5-4.2c.4-.9,1-1.8,1.6-2c.5-.1.9.2,1.2.7.2-.3.5-.3.7-.3.5.1.9.5,1.2,1.1.1-.2.3-.2.4-.2.6.1,1.1.7,1.3,1.6.2-.3.4-.3.7-.1.2.1.4.4.5.7c0-.2,0-.4.1-.5.2-.2.4.2.5.5.1.2.1.5.1.8s0,.6,0,.8c-.2,1.9-1.3,3.1-2,4.6-.2.5-.5,1.1-.8,1.5s-.6.6-.9.8c-.6.4-1.3.6-1.9.7-.2,0-.5,0-.7-.1-.4-.1-1,.1-1.3.7-.1.2-.2.5-.3.7-.1.3-.2.6-.3.9-.4,1.4-.8,2.8-1.2,4.2-.5,1.9-1,3.8-1.5,5.7-.4,1.7-.9,3.4-1.2,5.2-.1.6-.2,1.1-.3,1.7c0,.2-.1.6,0,.8v0c.8,1.1,1.9,1.6,2.7,2.6-.1.4-.3.6-.5,1-.2.6-.1,1,0,1.6.3,1.5.5,3.1.3,4.7-.1.8-.2,1.5-.4,2.2.1.8-.3,1.7-.7,2.4v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M126.8,155.6c-.1.2-.2.4-.3.5-.2.1-.4.1-.6.1-.5-.1-1-.4-1.5-.7-2.2-1.3-4.3-3.2-6.1-5.5-1.1-1.3-2.1-2.7-2.3-5.1c0-.3,0-.5,0-.8.2.9.6,1.6,1,2.2c1.4,2.2,3.1,4,4.9,5.3.2.1.3.2.5.2.3-.1.6-.6.7-1.1.5-1.5.7-3.2,1.1-4.7s1-3.1,2-3.7c-.1,2,.3,4,.7,5.9.3,1.6.7,3.3.8,5-.2.9-.5,1.7-.9,2.4v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M135.7,118.5c-.2.5-.5,1.1-.8,1.5s-.6.6-.9.8c-.6.4-1.3.6-1.9.7-.2,0-.5,0-.7-.1-.4-.1-1,.1-1.3.7-.1.2-.2.5-.3.7-.1.3-.2.6-.3.9-.4,1.4-.8,2.8-1.2,4.2-.5,1.9-1,3.8-1.5,5.7-.4,1.7-.9,3.4-1.2,5.2-.1.6-.2,1.1-.3,1.7c0,.2-.1.6,0,.8-.4-.4,0-3.4.1-3.9.1-1.4.3-2.9.5-4.3.4-2.8,1.1-5.6,2-8.1.8-2.3,1.8-4.6,3.5-5.2.9-.3,1.8-.4,2.7-.9.7-.4,1.3-1.1,1.9-1.9.8-1,1.6-2.3,1.9-3.8c0,.3,0,.6,0,.8-.5,1.8-1.6,3.1-2.2,4.5v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M130.9,108.5c-.8-.2-1.5,1.7-1.1,2.8.1.3.3.5.4.7s.2.5.3.8c0,.1,0,.1,0,.2s0,.2-.1.3c-.1.2-.2.3-.3.4s-.2.1-.3.3s0,.4,0,.6c.1.3.1.5.2.7s.3.4.5.3c.1,0,.2-.1.3-.1.1.1.2.2.2.4.2.5.8.5,1,.1.2.4.5.6.8.7.3,0,.6-.2.8-.5.1.4.4.7.7.7s.5-.2.8-.4c.4-.4.8-.8,1-1.4.3-.6.4-1.4.2-2.1-.2-.6-.5-1-.9-1.2-.1-.1-.3-.2-.4,0-.3-.4-.5-.7-.8-.9s-.7-.3-1,0c-.3-.8-.9-1.1-1.4-.7-.1-.8-.4-1.5-.9-1.7v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M135.1,147.7c-.3,0-1.6,3.3-1.6,3.6-.3,1.3-.1,2.6-.3,3.8c0,.1,0,.2,0,.4-.1,1.3.1,2.7.2,4c.1,1.9-.3,3.9-.5,5.8c0,0,0,.1,0,.1s0-.1-.1-.1c-2.6-2.8-4.5-6.1-7-9-.6-.7-1.2-1.3-1.8-2.1-.5-.6-.7-1.4-.9-2.1s-.4-1.5-.5-2.2c-.1-.4-.1-.8-.1-1.2c0-.7,0-1.5.2-2.2.3-1.1,1.2-2.1,2.2-2.8.4-.3.9-.6,1.4-.7.2-.1.5-.2.7-.2.3,0,.5.2.7.3c2.2,1.3,4.4,2.6,6.6,3.9.2.4.5.5.8.7v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M134.7,161.4c0,.6,0,1.3-.2,1.9-.3.8-.8,1.6-1.6,2c0,0-.1.1-.1.1-2.6-2.8-4.5-6.1-7-9-.6-.7-1.2-1.3-1.8-2.1-.5-.6-.7-1.4-.9-2.1s-.4-1.5-.5-2.2c.5.1,1,.5,1.4.9.8.6,1.4,1.4,2,2.2.2.2.7.5,1.2.5.2,0,.3,0,.5-.1.9-.6,1.3-2.1,1.8-3c.8-1.2,1.8-2.2,3.1-2.8-.7,2.1-.7,4.3.1,6.4.2.5.4,1,.7,1.5.2.6.5,1.1.7,1.6.3,1.3.6,2.8.6,4.2v0Z",
                fill: "#f0ece1"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M164.4,165c-.2,1.8-.9,3.4-1.5,5.1-.2.5-.4,1-.5,1.6-1.1,3.2-2,6.4-2.6,9.6-.5,2.8-.4,5.5-.6,8.3-.1,2-2.1,3.8-3.7,5-1.7,1.3-3.6,2.1-5.6,2.7c0,0-.1,0-.1,0-3.3,1-6.8,1.3-10.2.6-2.5-.5-4.9-1.6-6.7-3.3-1-.9-1.5-1.6-1.8-2.8-.3-1.3-.4-2.7-.5-4-.4-4.7-2-23.1-2-27.6c0-3.6.2-7.3,1.4-10.8.3-.8.7-2.1,1.3-2.7.8-.7,2.5-.7,3.5-.6c1.3.2,2.5.6,3.7,1.1.2.1.5.2.8.3c4.9,2,9.6,4.5,14.3,7c3.1,1.6,6.1,3.3,9.2,4.9.5.3.9.5,1.2,1c.5.7.3,1.5.3,2.3c0,.7.2,1.4.1,2.3v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M162.4,171.6c-1.1,3.2-2,6.4-2.6,9.6-.5,2.8-.4,5.5-.6,8.3-.1,2-2.1,3.8-3.7,5-1.7,1.3-3.6,2.1-5.6,2.7v-.4c-.1-3-.2-6-.2-9-.1-5.4.1-10.8.7-16.2.3-2.7.7-5.4,1.3-8.1.4-1.8,2.1-3,4.1-2.8c1.5.1,2.8.8,3.7,1.9c1,1,1.6,2.3,2,3.6.5,1.8.8,3.6.9,5.4v0Z",
                fill: "#f0ece1"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M149.5,157.4c-.6.7-1.5,1.3-2.4,1.8-1.6.9-3.2,1.7-5,2.2v0c-.2.1-.5.1-.8.2-1.2.2-2.6.2-3.6-.5-.4-.3-.8-.7-.8-1.3-.1-.7.3-1.3.2-2-.1-.5-.4-1-.5-1.5-.2-1.1.6-2.1,1.7-2.5c3.2-1.2,5.9-3.4,7.7-6.1.3.5.6,1,.9,1.6.6,1.2,1.1,2.5,2,3.6.5.6,1.2,1.3,1.4,2c.2.8-.1,1.8-.8,2.5v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M149.5,157.4c-.6.7-1.5,1.3-2.4,1.8-1.6.9-3.2,1.7-5,2.2.7-.7,1.4-1.4,2-2.2c1.3-1.9,1.7-4.4,1.1-6.6l-.2-.5c0-.7,0-1.5.4-2.1.3-.4.9-.7,1.4-.8.6,1.2,1.1,2.5,2,3.6.5.6,1.2,1.3,1.4,2c.3.9,0,1.9-.7,2.6v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M151.3,147.5c-.2,2.2-2.5,4.1-4.9,4.1-.2,1.2-1,2.3-2.1,3.1-1,.7-2.3,1.2-3.6,1.6-1.7.6-3.5,1-5.2,1.3-.7.1-1.5.2-2.2.1-.5-.1-1-.3-1.4-.6-.4-.4-.5-1-.7-1.5-.5-1.6-.9-3.3-1.3-4.9-.2-1-.5-1.9-.6-2.9-.2-1.7,0-3.5.3-5.1.2-1,.5-2.1.9-3.1.4-1.2.8-2.9,1.9-3.6c1.4-1,3.1-1.3,4.8-1.1c1.8.1,3.6.6,5.1,1.5c1.3.7,2.4,1.7,3.1,2.8.2.2.3.5.5.8.6,1.3.8,2.7,1.8,3.8.5.6,1.2,1,2,1.4.4.2.8.4,1.2.7s.5,1,.4,1.6v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M151.3,147.5c-.2,2.2-2.5,4.1-4.9,4.1-.2,1.2-1,2.3-2.1,3.1-1,.7-2.3,1.2-3.6,1.6-1.7.6-3.5,1-5.2,1.3-.7.1-1.5.2-2.2.1c1.4-.6,2.8-1.2,4-2.1c1.3-.9,2.4-2,3.2-3.3.7-1,1.2-2.1,1.3-3.2.1-1.3-.3-2.6-.5-3.9-.2-1.8-.1-3.7.5-5.4l.4.6c.4-.8,1.4-1.3,2.4-1.4.3,0,.6,0,.9,0c.2.2.3.5.5.8.6,1.3.8,2.7,1.8,3.8.5.6,1.2,1,2,1.4.4.2.8.4,1.2.7.3.5.4,1.2.3,1.8v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M154.1,141.6c0,1.5-.2,3.1-.8,4.5-.6,1.5-1.5,2.8-2.8,3.7.5-1.1.8-2.7.2-3.8-.3-.6-1.1-.8-1.7-.7-.7.1-1.3.5-1.7,1-1,.9-1.6,2.2-1.7,3.5-1.1-1.1-.4-2.9-1-4.3-.5-1.1-1.8-1.7-2.1-2.9-.2-1,.1-1.9-.7-2.5v0c-.1-.1-.2-.2-.4-.2-1.1-.5-2.3-.5-3.5-.5s-2.5-.1-3.4-.8c-.5-.4-.8-1-1.5-1.2-.5-.2-1,.1-1.4.4-.1.1-.2.2-.3.2c0,0-.1.1-.1.2-.1.2-.2.3-.3.5c0,.1-.1.2-.1.2c0-.5.1-1,.3-1.5.2-.4.3-.7.5-1.1.4-.7.9-1.4,1.4-2c1.4-1.5,3.2-2.6,5.2-3.3c1.5-.5,3.2-.8,4.8-.8c3.6.1,7.2,1.8,9.2,4.6.3.4.6.8.8,1.3.8,1.7,1.1,3.6,1.1,5.5v0Z",
              fill: "#94ebe1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M154.1,141.6c0,1.5-.2,3.1-.8,4.5-.6,1.5-1.5,2.8-2.8,3.7.5-1.1.8-2.7.2-3.8-.3-.6-1.1-.8-1.7-.7-.7.1-1.3.5-1.7,1-1,.9-1.6,2.2-1.7,3.5-1.1-1.1-.4-2.9-1-4.3-.5-1.1-1.8-1.7-2.1-2.9-.2-1,.1-1.9-.7-2.5.3,0,.6,0,.8,0c1.6-.1,3.1-.4,4.5-1.1.8-.3,1.5-.8,2.1-1.2c1.2-.8,2.2-1.9,3-3c.3.4.6.8.8,1.3.8,1.7,1.1,3.6,1.1,5.5v0Z",
              fill: "#94ebe1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M150.6,251.8c-.6,5.3-.1,10.7.7,15.9.3,2.3.6,4.7,1.2,6.9.6,1.9.6,3.1-1.1,4.6-1.1.9-2.5,1.5-3.8,2-1.5.6-3.1,1-4.7,1.4-1-6.1-1.9-12.2-2.5-18.4-.5-4.2-.8-8.4-.8-12.6.1-3.2.4-6.4.8-9.6.4-3.5.8-7.1,1.5-10.5.6-3.1,1.5-6.1,2.9-8.9.9-1.9,2.2-4.9,4.7-5.4c5.5-1.1,9.1,5.4,10.3,9.4-.2.4-.3.7-.5,1-4.4,7.8-7.7,15.5-8.7,24.2v0Z",
                fill: "#f0ece1"
              })
            ]),
            /*#__PURE__*/_createVNode("path", {
              d: "M138.8,212c-.3,1-1.2,1.6-2.2,2.1-2.1,1.1-4.4,1.8-6.8,2-.6.1-1.1.1-1.7.1-1.7.1-3.4-.1-5-.5-.7-.2-1.5-.5-1.9-1s-.3-.9-.1-1.3c.1-.2.2-.5.4-.8.3-.9.2-2,.2-3c0-1.4.3-2.5,1.2-3.6s2.1-1.9,3.3-2.8c1.6-1.3,2.9-3.2,4.9-4c.8-.3,1.6-.5,2.3-.7.1,0,.2-.1.3-.1.2-.1,2.2-.8,2.2-1.2.8,1.9.6,4,.9,6.1s1.1,4.1,1.8,6.1c.2,1,.4,1.8.2,2.6v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M138.8,212c-.3,1-1.2,1.6-2.2,2.1-2.1,1.1-4.4,1.8-6.8,2c.8-.6,1.4-1.3,2-2.1.6-.9,1.1-2,1.3-3.2.1-.6,0-1.3-.1-1.9-.1-.5-.2-.9-.3-1.3-.2-.8-.3-1.6-.5-2.4-.2-1.2-.5-2.5-.2-3.7.2-.9.6-1.7,1.1-2.4.1-.2.2-.3.3-.5.1,0,.2-.1.3-.1.2-.1,2.2-.8,2.2-1.2.8,1.9.6,4,.9,6.1s1.1,4.1,1.8,6.1c.2.9.4,1.7.2,2.5v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M139.3,195.8c-.3,1.5-.9,3-1.8,4.3-.5.7-1.1,1.3-1.9,1.7-.3.2-.8.3-1.2.3-.1,0-1-.2-1-.4-.7,1.5-.9,3.2-2.1,4.3-.4.4-1,.7-1.5,1-1.2.6-2.4,1-3.7,1.5s-2.7,1-4,1.3-2.4.5-3.6,0c-.1,0-.2-.1-.4-.2-.7-.3-.8-1.3-.9-1.9-.2-.9-.5-1.7-.6-2.6-.4-1.8-.6-3.5-.9-5.3-.2-1.6-.4-3.2-.5-4.8s.1-3.1.2-4.7c.1-1.3.2-2.7.3-4c.1-.7.1-1.6.6-2.2.4-.5,1.4-.7,2-1c2.1-.6,4.3-.7,6.5-.6c1.5.1,3.1.4,4.4,1.3.2.2.4.3.6.5c0,0,0,0,0,0c1.9,1.8,2.4,4.8,4.7,6.3.8.6,1.8.9,2.7,1.4s1.8,1.1,2.1,2c.1.5.1,1.2,0,1.8v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M139.3,195.8c-.3,1.5-.9,3-1.8,4.3-.5.7-1.1,1.3-1.9,1.7-.3.2-.8.3-1.2.3-.1,0-1-.2-1-.4-.7,1.5-.9,3.2-2.1,4.3-.4.4-1,.7-1.5,1-1.2.6-2.4,1-3.7,1.5s-2.7,1-4,1.3-2.4.5-3.6,0c1.7-.9,3.4-2,4.8-3.4c2.3-2.2,3.9-5.2,4-8.2.1-3.1-1.4-6.2-.7-9.3.2-.9.5-2.1,1-2.8.2-.2.5-.4.7-.6.3-.3.5-.7.9-1c.2-.1.4-.2.6-.2c0,0,0,0,0,0c1.9,1.8,2.4,4.8,4.7,6.3.8.6,1.8.9,2.7,1.4s1.8,1.1,2.1,2c.1.5.1,1.2,0,1.8v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M142.2,189.5c-.1,2.1-.6,4.1-1.3,6-.3.8-.7,1.5-1.1,2.3s-1,1.6-1.8,2.2c-.3.2-.8.4-1,.7.6-.9,1.2-1.8,1.5-2.9.3-1.3.2-4-2-3.8-.7.1-1.3.5-1.8,1-.7.7-1.2,1.6-1.6,2.6-.2.4-.3.9-.5,1.3-.1.2-.7,1.2-.5,1.4-.6-.9-.6-2-.7-3-.2-1.4-.8-2.8-1.7-3.9-.8-1-1.9-1.9-2-3.1-.1-1,.5-2,.7-3c.1-.2.1-.4,0-.6-.1-.3-.4-.5-.8-.6-.1,0-.1,0-.2,0-.4,0-.8.1-1.3.2-2.3.7-4.7.8-7,.4-1-.2-2.8-.4-2.9-1.5-.2.8-.4,1.7-.5,2.6-.1.8-.4,1.8-.3,2.6-.2-1.4-.3-2.9,0-4.3.5-2.5,2.7-4.8,4.8-6.3c1.4-.9,3-1.5,4.6-1.8c3-.6,6-.5,9,.3c2.1.6,4,1.6,5.5,3c.3.3.5.6.8.9c1.6,1.9,2.2,4.7,2.1,7.3v0Z",
              fill: "#fd8480"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M142.2,189.5c-.1,2.1-.6,4.1-1.3,6-.3.8-.7,1.5-1.1,2.3s-1,1.6-1.8,2.2c-.3.2-.8.4-1,.7.6-.9,1.2-1.8,1.5-2.9.3-1.3.2-4-2-3.8-.7.1-1.3.5-1.8,1-.7.7-1.2,1.6-1.6,2.6-.2.4-.3.9-.5,1.3-.1.2-.7,1.2-.5,1.4-.6-.9-.6-2-.7-3-.2-1.4-.8-2.8-1.7-3.9-.8-1-1.9-1.9-2-3.1-.1-1,.5-2,.7-3c.1-.2.1-.4,0-.6-.1-.3-.4-.5-.8-.6.1,0,.2,0,.3,0c.8,0,1.7.1,2.5,0c.9-.1,1.7-.2,2.5-.5.9-.3,1.8-.6,2.6-1.1c1.4-.8,2.7-1.9,3.7-3.1.3.3.5.6.8.9c1.7,1.8,2.3,4.6,2.2,7.2v0Z",
              fill: "#fdb4b1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M166.5,236.2c0,0,8.5-2.4,7-11.1l-2.4-.9-7.7.3-1.7,4.1.3,5.3l1.8,2.6l2.7-.3v0Z",
              fill: "#e1d1a4"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M237.5,267.1c-.2.1-.5.1-.7,0-1.5-.3-5.9-2.6-6.2-2.8-1.5-.9-2.9-1.9-4.4-2.8s-3-1.7-4.7-2.3c-.7-.2-1.6-.3-2,.3-.2.3-.2.7-.1,1c.2,1.1.9,2.2,1.5,3.2s1.1,2.2.8,3.4c-.1.3-.2.6-.5.8-.1,0-.2.1-.3.1v0c-.6.1-1.2-.4-1.6-.9-2.1-2.7-4-5.6-5.5-8.7-1.2-2.5-2.5-5.1-5.6-5.9-8.2-2.1-16-5.1-23.8-8.1-2-.8-4-1.5-6-2.5-2.5-1.3-4.9-2.8-7.4-4.1-2.7-1.3-5.4-2.6-8.2-3.8-1.6-.7-3.1-1.4-4.7-2.2-1.3-.7-2.6-1.4-3.8-2.1-.7-.4-1.3-.8-1.9-1.4.3.3,3.2-.9,3.6-1c1.2-.4,2.4-.9,3.5-1.5c1.8-1.1,3.7-3.2,4.4-5.1c2.8,1.1,5.2,2.8,7.9,4.1c2.1,1,4.3,1.9,6.6,2.7c3.1,1,6.2,1.9,9.2,3.1c2.6,1.1,4.8,3.1,6.9,4.8c2,1.6,4.3,2.8,6.3,4.2c3.2,2.1,6.5,4.2,9.7,6.3c1.1.7,6,3.6,6.8,3.9c1.5.7,3,1.4,4.5,2.2c2.4,1.4,4.5,3,6.7,4.7c2,1.5,4,3.1,5.7,4.8.6.6,3,3,3.5,4.5.2.5.1.9-.2,1.1v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M221,268v0c-.6.2-1.2-.4-1.6-.9-2.1-2.7-4-5.6-5.5-8.7-1.2-2.5-2.5-5.1-5.6-5.9-8.2-2.1-16-5.1-23.8-8.1-2-.8-4-1.5-6-2.5-2.5-1.3-4.9-2.8-7.4-4.1-2.7-1.3-5.4-2.6-8.2-3.8-1.6-.7-3.1-1.4-4.7-2.2c0-.1,0-.2,0-.3.4-3.1,2.5-6,5.6-7c1.3-.4,2.8-.5,4.2-.6.6,0,1.3,0,1.8.3.9.6.2.7-.5,1-1.3.5-2.2,1.7-2.3,3-.2,1.6.5,3.2,1.6,4.4s2.5,2.1,4,3c7.2,4.2,15,7.3,23.1,9.6c4,1.2,8,2.1,11.8,3.8c2.1.9,4,2.1,5.5,3.6c1.4,1.4,2.3,3.1,3.2,4.8c1.2,2.3,2.3,4.6,3.2,7c.4.9,1,1.8,1.3,2.7.2.4.2.7.3.9v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M173.5,225.2c-.4-.2-1.5-.1-2-.1-.7,0-1.5,0-2.2.1-1.4.2-2.7.5-3.7,1.5-.7.7-1.3,1.5-1.5,2.3-.1.4-.2.8-.3,1.2-.1.5-.1,1-.1,1.5.1.8.3,1.7.8,2.4.4.8,1,1.8,2,2.1-3.7,1.7-7.8,2.4-11.9,2-.7-.1-1.5-.2-2.2-.4s-1.5-.6-2-1.1c-.6-.5-1.3-1.2-1.7-1.8-.9-1.3-1.6-2.8-1.9-4.4-.2-1.2-.4-2.4-.4-3.6-.1-3,.4-6.1,1.5-8.9c0,0,0,0,0,0c.5-1.2,1.3-2.5,2.5-3.1s2.7-.5,3.9-.2c1.3.3,2.4,1,3.6,1.6c5.3,2.9,10.4,5.9,15.6,8.9v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M166.5,236.2c-3.7,1.7-7.8,2.4-11.9,2-.7-.1-1.5-.2-2.2-.4s-1.5-.6-2-1.1c-.6-.5-1.3-1.2-1.7-1.8-.9-1.3-1.6-2.8-1.9-4.4-.2-1.2-.4-2.4-.4-3.6-.1-3,.4-6.1,1.5-8.9c0,0,0,0,0,0c0,.2.1.3.1.4.2.6.4,1.2.6,1.8.3,1,.8,2.1,1.4,3c.2.2.3.5.5.7c1.2,1.3,2.8,2.9,4.4,3.6c2.9,1.3,5.9,2.2,9,2.8-.1.5-.1,1-.1,1.5.1.8.3,1.7.8,2.4.3.7.9,1.7,1.9,2v0Z",
                fill: "#f0ece1"
              })
            ])
          ]),
          /*#__PURE__*/_createVNode("path", {
            d: "M161.4,218.3c-2.6-.1-5.2,0-7.7.6-2.8.6-4.6,1.8-6.7,3.6-1.7,1.5-3.4,3-4.7,4.8-1,1.3-1.8,2.6-2.6,4-1.5,2.9-2.9,5.9-3.4,9.1-.5,3.3-1,6.6-1.4,9.9-.5,3.8-2.6,7.8-5.8,10.3-.8.6-1.7,1.2-2.7,1.8-1.8,1-3.8,2-5.9,2.4-2.1.5-4.4.4-6.4-.4-.3-.1-.7-.4-.6-.7.1-.5.8-.7,1.2-1c.5-.4.9-.9,1.3-1.4.9-1,1.7-2.1,2.3-3.2c1-2,2.1-4,3-6.1c4.4-10.9,1.5-23.6,7-34c1-1.9,2.3-3.7,4.1-5c1.5-1,3.2-1.6,4.9-2c2-.4,4-.6,6.1-.7.6.2,1.1.4,1.6.6c2.8,1,5.5,2.1,8.3,3.1c1.4.5,2.7,1.1,3.9,1.9.2.1.5.2.7.4c1.2.7,2.3,1.3,3.5,2v0Z",
            fill: "#f0e1b6"
          }),
          /*#__PURE__*/_createVNode("g", null, [
            /*#__PURE__*/_createVNode("path", {
              d: "M132,253.1c-.3.7-.9,1.3-1.5,1.8-1,.9-2.3,1.6-3.1,2.7-.6.8-1,1.8-1.5,2.7-1,1.8-2.8,3.2-4.7,4-2,.8-4.3.9-6.4.3-.7-.2-1.8-.6-2.3-1.2-.2-.2-.2-.5-.2-.7c0-.6.5-1.2.9-1.7c1.7-2.1,3.3-4.1,5-6.2.6-.7,1.2-1.5,1.8-2.2c1-1.3,2.1-2.6,3.1-3.9.1-.2.2-.3.3-.4.9-1.2,2-1.9,3.7-1.7c1.5.2,2.7,1,3.7,2c.6.6,1.1,1.3,1.4,2.1.1.8.2,1.7-.2,2.4v0Z",
              fill: "#fd8480"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M132,253.1c-.3.7-.9,1.3-1.5,1.8-1,.9-2.3,1.6-3.1,2.7-.6.8-1,1.8-1.5,2.7-1,1.8-2.8,3.2-4.7,4-2,.8-4.3.9-6.4.3-.7-.2-1.8-.6-2.3-1.2-.2-.2-.2-.5-.2-.7c1.5.2,3.1.3,4.6.1c2.1-.2,4.1-1,5.6-2.3c1.7-1.5,2.7-3.6,4.4-5.1c1-.9,1.2-2.5.3-3.5-.8-.9-2.2-.8-3.2-1.3c0,0,0,0-.1,0-.7-.4-1-1.1-1-1.8.1-.2.2-.3.3-.4.9-1.2,2-1.9,3.7-1.7c1.5.2,2.7,1,3.7,2c.6.6,1.1,1.3,1.4,2.1.3.7.4,1.6,0,2.3v0Z",
              fill: "#fdb4b1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M159.4,206.8c-2.4,6.3-9.8,10.1-16,12.4-.9.4-11.7,4.5-11.8,4.2c1.2,3.2,1.4,6.7,1.2,10.2c0,.6-.1,1.2-.1,1.9-.2,2.4-.5,4.8-.9,7.2-.2,1.2-.5,2.4-.8,3.5-.2.9-.4,1.9-.9,2.7-.2.4-.6.7-1.1.9-.7.3-1.5.4-2.3.4-.7,0-1.4.1-2-.1-.5-.1-1.1-.3-1.5-.6s-.4-.7-.5-1.1c-.4-2.8-4-26.7-3.5-29.6.3-2.2,3-3.9,4.8-5c2.2-1.5,4.3-3,6.3-4.5c4.1-3,8.1-6.2,12.1-9.2.3-.2.7-.5,1-.7.5-.4.9-.7,1.4-1c1.7-.1,3.3-.4,5-.9c2.1-.6,4-1.5,5.7-2.8c1.3-1,2.9-2.3,3.4-3.9.1.1.2.2.3.4.8,1.3,1.2,2.6,1.5,4c.1.4.1.8.2,1.2.3,3.3-.2,7-1.5,10.4v0Z",
              fill: "#5289a1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M159.4,206.8c-2.4,6.3-9.8,10.1-16,12.4-.9.4-11.7,4.5-11.8,4.2c1.2,3.2,1.4,6.7,1.2,10.2c0,.6-.1,1.2-.1,1.9-.2,2.4-.5,4.8-.9,7.2-.2,1.2-.5,2.4-.8,3.5-.2.9-.4,1.9-.9,2.7-.5-7.4-1.1-14.9-1.7-22.3-.2-1.8-.2-3.7.7-5.4.3-.6.8-1.1,1.3-1.5.7-.5,1.5-.9,2.4-1.2c2.7-.9,5.3-1.9,7.9-3.1c3.6-1.5,7.2-3.3,10.2-5.8c2.9-2.5,5.1-6,5.3-9.7.1-.9-.1-2-1-2.5-1-.6-2.3,0-3.3.5-1.7.8-3.5,1.3-5.4,1.5-1,.1-2.2.1-3.1-.2.5-.4.9-.7,1.4-1c1.7-.1,3.3-.4,5-.9c2.1-.6,4-1.5,5.7-2.8c1.3-1,2.9-2.3,3.4-3.9.1.1.2.2.3.4.8,1.3,1.2,2.6,1.5,4c.1.4.1.8.2,1.2.3,3.5-.2,7.2-1.5,10.6v0Z",
              fill: "#5289a1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M175.6,169.5c0,0,4.2-6.6-1.5-8.7l-4.3.3-3,4.4l1.8,4.6l3.9,1.5l3.1-2.1v0Z",
              fill: "#e1d1a4"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M224.2,162.7c0,.2-.1.4-.2.6-.2.3-.4.6-.7.7-.3.2-.6.3-.9.4-.6.2-1.2.3-1.8.5-1.1.3-2.3.6-3.4.8-1.7.3-3.5.3-5.2.1-.6-.1-1.3-.2-1.9-.1.9.2,1.8.4,2.8.6.3.1.7.2.9.5s.3.7.1,1c0,.1-.1.2-.2.3-.5.4-1.2.4-1.8.3-1.2-.1-2.5,0-3.7.2-.8.1-1.5.3-2.3.4-1.1.1-2.2-.2-3.1-.9-.4-.3-.7-.7-1-1.2-5.5.6-11,1.3-16.5,1.9-3.2.3-6.5.3-9.8.5-1.1.1-2.2.2-3.3.3-.6.1-1.1.1-1.7.2-.4,0-.8,0-1.2,0-1,0-2.1.1-3.1,0-.1,0-.3,0-.5-.1v0c-.6-.1-1.4-.4-1.6-.6-.1-.1,0-.2,0-.3.1-.3.2-.6.3-.9.3-.7.7-1.4,1-2.2.5-1.2.8-2.4.9-3.7c0-.7,0-1.3,0-2c.9,0,1.7.1,2.6.2.6.1,1.3.2,1.9.3.7.1,1.5.2,2.2.2c1,0,2.2,0,3.2-.2c2.4-.5,4.9-.9,7.4-1c2.6-.1,13.2,1.2,15.8,1.4c1.3.1,6.3.8,7.6,1c0,0,.1,0,.1,0c1.3.2,2.5.3,3.8.4c2.5.1,5.1-.1,7.6-.5.7-.1,1.4-.3,2.1-.2.4,0,.8.2,1.3.2.4,0,.8-.1,1.3,0c.6.2,1,.5,1,.9v0Z",
              fill: "#fdcdb1"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M213.9,167.8c0,.1-.1.2-.2.3-.5.4-1.2.4-1.8.3-1.2-.1-2.5,0-3.7.2-.8.1-1.5.3-2.3.4-1.1.1-2.2-.2-3.1-.9-.4-.3-.7-.7-1-1.2-5.5.6-11,1.3-16.5,1.9-3.2.3-6.5.3-9.8.5-1.1.1-2.2.2-3.3.3-.6.1-1.1.1-1.7.2-.4,0-.8,0-1.2,0-1,0-2.1.1-3.1,0-.1,0-.3,0-.5-.1v0c-.1-.1-.2-.2-.2-.2-.4-.5-.8-1-1-1.6-.4-.9-.5-1.9-.3-2.9.3-1.2,1.2-2.1,2.2-2.9.6-.5,1.2-.9,1.8-1.3.2-.1.5-.3.7-.4.6.1,1.3.2,1.9.3-.7,1.8-2.4,3.8-.7,5.6.9,1,2.4,1.2,3.8,1.3c1.7.2,3.5.2,5.2.1c3.8-.2,7.5-1.2,11.2-1.9s7.6-1.2,11.4-.4c2.1.4,4.1,1.3,6.2,1.7c2.2.3,4.1.5,6,.7v0Z",
              fill: "#fdbd97"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M175.6,169.5c-.7.7-1,1.6-1.7,2.4-.8.9-1.9,1.4-3.1,1.7s-2.4.3-3.7.4c-2.1.1-4.2.1-6.2-.1-1.4-.1-2.9-.5-4.1-1.3-.7-.5-1.5-1.1-2-1.8-.8-1.1-1.6-2.2-2-3.5-.5-1.6-.7-3.3-.4-4.9c0-.1,0-.2.1-.4.3-1.4,1-2.7,2-3.7.5-.5.9-.9,1.6-1.1.8-.2,1.6-.3,2.4-.2c1.1.1,2.1.4,3.2.8.1,0,.3.1.4.1c3.9,1.2,8,2,12,2.8-1.5.3-3,1-4.2,2-1,.9-1.5,2.4-1.5,3.7c0,.9.2,1.7.8,2.4c0,0,0,0,0,0c.7.8,1.9,1.2,3,1.2c1.2.1,2.3-.2,3.4-.5v0Z",
              fill: "#f0ece1"
            }),
            /*#__PURE__*/_createVNode("g", null, [
              /*#__PURE__*/_createVNode("path", {
                d: "M175.6,169.5c-.7.7-1,1.6-1.7,2.4-.8.9-1.9,1.4-3.1,1.7s-2.4.3-3.7.4c-2.1.1-4.2.1-6.2-.1-1.4-.1-2.9-.5-4.1-1.3-.7-.5-1.5-1.1-2-1.8-.8-1.1-1.6-2.2-2-3.5-.5-1.6-.7-3.3-.4-4.9.1.8.4,1.6.9,2.3.8,1.2,2,2.1,3.4,2.8c2.3,1.1,4.9,1.5,7.5,1.6c1.7.1,3.4.1,5.1-.2.7.8,1.9,1.2,3,1.2s2.2-.3,3.3-.6v0Z",
                fill: "#f0ece1"
              })
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "e9OQsJvkrHt105_to",
        transform: "translate(566.651986,234.96461)"
      }, [
        /*#__PURE__*/_createVNode("g", { transform: "translate(-369.505341,-230.239189)" }, [
          /*#__PURE__*/_createVNode("g", null, [
            /*#__PURE__*/_createVNode("path", {
              d: "M357.2,179.5c-20.9,12.5-38.2,45.2-38.8,73.1s15.9,40.4,36.7,27.9c6.2-3.7,12.1-9.2,17.3-15.9-2.6,2.5-5.3,4.6-8.1,6.2-15.7,9.1-28.2-.3-28-20.9s13-44.7,28.7-53.7c15.7-9.1,28.2.3,28,20.9c0,.1,0,.2,0,.4.5-3.4.8-6.8.9-10.1.6-27.9-15.9-40.4-36.7-27.9v0Z",
              fill: "url(#e9OQsJvkrHt107-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M406.9,215c-.7-27.4-18.9-40.4-40.7-29s-38.9,42.8-38.2,70.2s18.9,40.4,40.7,29s38.9-42.8,38.2-70.2v0Zm-42.8,55.9c-15.7,9.1-28.2-.3-28-20.9s13-44.7,28.7-53.7c15.7-9.1,28.2.3,28,20.9-.2,20.5-13,44.6-28.7,53.7v0Z",
              fill: "url(#e9OQsJvkrHt108-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M368.1,193.1c-7.5,4.2-14.3,11.4-19.9,20c4.7-7.2,10.5-13.3,16.8-16.9c15.7-9.1,28.2.3,28,20.9s-13,44.7-28.7,53.7c-15.7,9.1-28.2-.3-28-20.9.1-8.3,2.2-17.1,5.7-25.3-4.2,9.5-6.7,19.9-6.7,29.6-.1,23.5,14.5,34.3,32.5,24.1s32.7-37.6,32.8-61.2-14.5-34.3-32.5-24v0Z",
              fill: "url(#e9OQsJvkrHt109-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M385.3,233.4c6.2-13.9,17.9-22.2,26-18.5s9.8,17.9,3.5,31.8c-6.2,13.9-17.9,22.2-26,18.5s-9.7-17.9-3.5-31.8Z",
              fill: "url(#e9OQsJvkrHt110-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M389.7,236c6.2-13.9,17.9-22.2,26-18.5c8.2,3.7,9.8,17.9,3.5,31.8-6.2,13.9-17.9,22.2-26,18.5s-9.7-17.9-3.5-31.8Z",
              fill: "url(#e9OQsJvkrHt111-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M319.4,259.3c6.3-13.8,19.1-21.6,28.5-17.3c9.5,4.3,12,19,5.7,32.9-6.3,13.8-19.1,21.6-28.5,17.3s-12-19-5.7-32.9Z",
              fill: "url(#e9OQsJvkrHt112-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M324.1,262.5c6.3-13.9,18.5-21.8,27.4-17.8s11,18.5,4.8,32.4c-6.3,13.9-18.5,21.8-27.4,17.8-8.9-4.1-11.1-18.6-4.8-32.4Z",
              fill: "url(#e9OQsJvkrHt113-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M345.5,179.7c7.8-12.7,21.2-18.6,30.1-13.1c8.8,5.4,9.7,20.1,2,32.7-7.8,12.7-21.2,18.6-30.1,13.1-8.9-5.4-9.8-20-2-32.7Z",
              fill: "url(#e9OQsJvkrHt114-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M349.7,181.9c7.7-12.7,21-18.7,29.6-13.4s9.4,19.8,1.6,32.5-21,18.7-29.6,13.4c-8.6-5.2-9.4-19.8-1.6-32.5Z",
              fill: "url(#e9OQsJvkrHt115-fill)"
            })
          ]),
          /*#__PURE__*/_createVNode("g", null, [
            /*#__PURE__*/_createVNode("path", {
              d: "M376.4,196.9L355,204.3c-.7.2-1.2-.2-1.3-1l-.3-15.5c0-.8.5-1.6,1.2-1.8l21.4-7.4c.7-.2,1.2.2,1.3,1l.3,15.5c0,.7-.5,1.5-1.2,1.8v0Z",
              fill: "#fdbe09"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M362.7,191.2c.3-.5,1-1.2,1.9-1.7.1-.1.6-.3,1.3-.5.9-.2,1.6,0,2,.2.5.2,1,.5,1.5.7l8.1,4.3v.1.7c0,.3-.1.7-.3,1.1-.2.3-.5.6-.9.7l-21.4,7.4c-.7.2-1.2-.2-1.3-1v0-.7-.1c2-2.5,4.1-5.1,6.1-7.6c1.1-1.2,2.1-2.4,3-3.6v0Z",
              fill: "#fd9f00"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M359.9,196.2c1-1.2,1.9-2.4,2.9-3.6.3-.5,1-1.2,1.9-1.7.1-.1.6-.3,1.3-.5.9-.2,1.6,0,2,.2.5.2,1,.5,1.5.7c2.7,1.4,5.3,2.8,8,4.3.1-.2.1-.4.1-.6v-.7-.1l-8.1-4.3c-.5-.2-1-.5-1.5-.7s-1.1-.4-2-.2c-.7.1-1.2.4-1.3.5-.9.5-1.6,1.3-1.9,1.7-1,1.2-1.9,2.4-2.9,3.6-2,2.5-4.1,5.1-6.1,7.6v.1.7v0c0,.2,0,.3.1.5c1.9-2.5,4-5,6-7.5v0Z",
              fill: "#fc7201"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M368.3,191.5c-.3.5-1,1.2-1.9,1.7-.1.1-.6.3-1.3.5-.9.2-1.6,0-2-.2-.5-.2-1-.5-1.5-.7l-8.1-4.3v-.1-.7c0-.3.1-.7.3-1.1.2-.3.5-.6.9-.7l21.4-7.4c.7-.2,1.2.2,1.3,1v0v.7.1c-2,2.5-4.1,5.1-6.1,7.6-1,1.2-2,2.4-3,3.6v0Z",
              fill: "#fdd34f"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M371.2,186.6c-1,1.2-1.9,2.4-2.9,3.6-.3.5-1,1.2-1.9,1.7-.1.1-.6.3-1.3.5-.9.2-1.6,0-2-.2-.5-.2-1-.5-1.5-.7-2.7-1.4-5.3-2.8-8-4.3-.1.2-.1.4-.1.6v.7.1l8.1,4.3c.5.2,1,.5,1.5.7s1.1.4,2,.2c.7-.1,1.2-.4,1.3-.5.9-.5,1.6-1.3,1.9-1.7c1-1.2,1.9-2.4,2.9-3.6c2-2.5,4.1-5.1,6.1-7.6v-.1-.7v0c0-.2,0-.3-.1-.5-2,2.5-4,5-6,7.5v0Z",
              fill: "#fc7201"
            })
          ]),
          /*#__PURE__*/_createVNode("path", {
            d: "M392.8,245.1l18.7-14.8c.9-.7,1.6-.3,1.4,1.3v0L410,250c-.2,1.3-.8,1.8-1.7,1.6l-5-2.4-2.3,3.4c-.3.4-.5.7-1,.9l.2-5.8l8.9-12.5c.4-.5-.1-.6-.6,0l-11,11.9-4.9-.1c-1,0-1-.8.2-1.9v0v0Z",
            fill: "#fff"
          })
        ])
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "e9OQsJvkrHt123_to",
        transform: "translate(536.309273,391.999992)"
      }, [
        /*#__PURE__*/_createVNode("g", { transform: "translate(-350.290344,-299.995193)" }, [
          /*#__PURE__*/_createVNode("g", null, [
            /*#__PURE__*/_createVNode("path", {
              d: "M305.3,280.9c0-14.8,4.6-25.5,12.1-30.6v0v0c.9-.6,1.9-1.2,2.9-1.7l10.4-6c6.8-4,15.8-3.7,25.6,2c21.5,12.4,39,45.7,39,74.4c0,15.4-5,26.3-13,31.2v0c-.4.3-12,6.8-12,6.8-6.9,4.3-16,4-26-1.7-3.9-2.3-7.7-5.2-11.3-8.7l-16.6-23.1c-6.9-13.2-11.1-28.5-11.1-42.6v0Z",
              fill: "url(#e9OQsJvkrHt125-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M320.8,248.4c17.2-7.3,41.6,11.4,54.6,41.8c12.9,30.4,9.5,61-7.7,68.3s-41.6-11.4-54.6-41.8c-12.9-30.4-9.5-61,7.7-68.3Z",
              fill: "url(#e9OQsJvkrHt126-fill)"
            })
          ]),
          /*#__PURE__*/_createVNode("g", null, [
            /*#__PURE__*/_createVNode("path", {
              d: "M356.4,295.6c.5,1.6.9,3.2,1.2,4.7c3.3,2,7,7.8,9.4,14.6c1.5,4,2.3,8.2,2.3,12.4c0,1.6,0,3.9-1.5,5.2-.5.4-1,.7-1.3.8-1.2.4-2.4.7-3.6,1.1-.3-1.1-.8-2.2-1.3-3.4-1.5-3.3-3.4-5.8-5.1-7.6-.4.6-.9,1.3-1.8,2-1.9,1.6-5.4,3.2-7.3,1.7-.3-.3-.9-.8-1.1-2.1v0c.8,7-.5,12-3.2,12.5v0c0,0-.3.2-1,.6-.6.3-1.5.7-2.5.5-5.2-.8-7-14.1-7.4-17.4-.5-3.9-.8-9.6.3-16.6-.4-1-.9-2.5-1.5-4.5-1.7-5.7-7.5-24.8-.7-29.8c1.7-1.3,3.8-1.2,5-1.2c12.8.4,20.8,25.5,21.1,26.5v0Z",
              fill: "url(#e9OQsJvkrHt128-fill)"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M353,296.7c.5,1.6.9,3.2,1.2,4.7c3.3,2,7,7.8,9.4,14.6c1.5,4,2.3,8.2,2.3,12.4-.1,3.5-1.1,5.6-2.8,6h-.1c-2.7.5-6.7-3.5-9.9-9.9-.9,1.6-2.5,2.8-4.3,3.2-2,.3-4.1-.3-5.9-1.5v0c.8,7-.5,12-3.2,12.5h-.1c-3.6.4-8.5-6.9-10.8-16.4-1.8-7.1-1.6-13.8.3-16.6-.5-1.5-1-3-1.5-4.5-4.7-15.8-2.8-29.7,4.2-31c6.9-1.2,16.5,10.6,21.2,26.5v0Z",
              fill: "#fff"
            })
          ])
        ])
      ]),
      /*#__PURE__*/_createVNode("g", {
        id: "e9OQsJvkrHt130_to",
        transform: "translate(217.150005,480.685734)"
      }, [
        /*#__PURE__*/_createVNode("g", { transform: "translate(-220.650009,-357.348205)" }, [
          /*#__PURE__*/_createVNode("path", {
            d: "M267.2,340.4h-93.2c-1.3,0-2.5-.5-3.5-1.3-.9-.8-1.4-2-1.4-3.2v-8.8c0-2.5,2.2-4.6,4.9-4.5h93.3c2.7,0,4.9,2,4.9,4.5v0v8.8c-.1,2.5-2.3,4.5-5,4.5v0Z",
            fill: "#b28c66"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M179.5,335.9v-8.8c0-2.6,2.3-4.6,5-4.5h-10.4c-2.7,0-5,2-5,4.5v8.8c0,2.6,2.3,4.6,5,4.5h10.4c-2.7.1-5-2-5-4.5Z",
            opacity: "0.1"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M265.5,340.4h-89.8v47c0,2.6,2.3,4.6,5,4.6h79.8c2.7,0,5-2,5-4.6v-47v0v0Z",
            fill: "#b28c66"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M265.5,350.4v-9.9h-89.8v47c0,2.6,2.3,4.6,5,4.6h8.4c-2.7,0-5-2-5-4.6v-37l81.4-.1v0Z",
            opacity: "0.1"
          }),
          /*#__PURE__*/_createVNode("g", { transform: "translate(44 7)" }, [
            /*#__PURE__*/_createVNode("path", {
              d: "M160.4,326.4c-.8,0-1.5-.6-1.5-1.4v-2.6c0-.8.7-1.4,1.5-1.4s1.5.6,1.5,1.4v2.6c0,.4-.2.7-.4,1-.3.2-.7.4-1.1.4Z",
              fill: "#4a5058"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M157.5,329.1c0-.8.6-1.4,1.5-1.4h2.8c.8,0,1.5.7,1.5,1.4c0,.8-.6,1.4-1.5,1.4h-2.8c-.4,0-.8-.2-1-.4-.3-.3-.5-.6-.5-1v0Z",
              fill: "#a07e5c"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M195.6,326.4c-.8,0-1.5-.6-1.5-1.4v-2.6c0-.8.7-1.4,1.5-1.4s1.5.6,1.5,1.4v2.6c0,.8-.7,1.4-1.5,1.4Z",
              fill: "#4a5058"
            }),
            /*#__PURE__*/_createVNode("path", {
              d: "M192.7,329.1c0-.8.6-1.4,1.5-1.4h2.8c.8,0,1.5.7,1.5,1.4c0,.8-.6,1.4-1.5,1.4h-2.8c-.8,0-1.5-.6-1.5-1.4Z",
              fill: "#a07e5c"
            }),
            /*#__PURE__*/_createVNode("g", {
              id: "e9OQsJvkrHt140_ts",
              transform: "translate(178.010071,326.009171) scale(1.145709,1.292788)"
            }, [
              /*#__PURE__*/_createVNode("g", { transform: "translate(-178.010071,-326.00917)" }, [
                /*#__PURE__*/_createVNode("path", {
                  d: "M178,328.4c-2.2,0-4.3-.9-5.8-2.4-.4-.4-.5-.9-.3-1.4s.6-.8,1.2-.9c.5-.1,9.9-.2,10.6.3.6.5.7,1.3.2,1.9c0,0,0,0-.1.1-1.5,1.5-3.6,2.4-5.8,2.4v0Z",
                  fill: "#4a5058"
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createVNode("path", {
            d: "M239,373.9l3.5,4.1",
            fill: "none",
            stroke: "#58bf60",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-miterlimit": "10"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M251.5,369.8l-9,8.2",
            fill: "none",
            stroke: "#58bf60",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-miterlimit": "10"
          }),
          /*#__PURE__*/_createVNode("path", {
            d: "M244.6,386.6c7.5,0,13.6-5.7,13.6-12.7s-6.1-12.7-13.6-12.7-13.6,5.7-13.6,12.7s6.1,12.7,13.6,12.7Z",
            fill: "none",
            stroke: "#58bf60",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-miterlimit": "10"
          })
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.channelState === true)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
}